/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProductList, getSystemSettingList, getSystemSettingGetSettingUrlList } from '@/api';
export default {
  name: 'home',
  data: function data() {
    return {
      bannerList: [],
      seachForm: {
        keyword: '',
        fk_t_shop_classification_id: 0,
        pageIndex: 0,
        pageSize: 10
      },
      list: [],
      loading: false,
      finished: false,
      isPullLoading: false,
      // 上拉加载
      upFinished: false,
      // 上拉加载完毕
      offset: 100 // 滚动
    };
  },
  methods: {
    onSearch: function onSearch() {},
    onCancel: function onCancel() {
      console.log('AutoConsole: onCancel -> onCancel');
      this.seachForm.keyword = '';
      this.onLoad(true);
    },
    onLoad: function onLoad() {
      var _this = this;
      var bol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (bol) {
        this.seachForm.pageIndex = 0;
      }
      this.loading = true;
      return getProductList(_objectSpread({}, this.seachForm)).then(function (res) {
        if (res.success) {
          if (bol) {
            _this.list = res.data;
          } else {
            _this.list = _this.list.concat(res.data);
          }
          if (res.data == null || res.data.length < 1) {
            _this.upFinished = true; // 加载结束
          }
          if (res.data.length < _this.seachForm.pageSize) {
            _this.upFinished = true; // 最后一页不足10条的情况
          }
        }
        _this.loading = false;
      });
    },
    onRefresh: function onRefresh() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.isPullLoading = true;
                _context.next = 3;
                return _this2.onLoad(true);
              case 3:
                _this2.isPullLoading = false;
                _this2.$vux.toast.text(i18n.tc("641"));
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    goDetail: function goDetail(item) {
      this.$router.push("/serviceMall/classification/classificationList/".concat(item.fk_t_shop_goods_id));
    },
    onLoadList: function onLoadList() {
      this.seachForm.pageIndex++;
      this.onLoad();
    },
    init: function init() {
      var _this3 = this;
      getSystemSettingList({
        category_type: 12
      }).then(function (res) {
        if (res.success) {
          var tmp = res.data.find(function (v) {
            return v.code === 120002;
          }) || {};
          getSystemSettingGetSettingUrlList({
            id: tmp.id
          }).then(function (res2) {
            if (res2.success) {
              _this3.bannerList = res2.data;
            }
          });
        }
      });
    }
  },
  created: function created() {
    this.seachForm.pageIndex = 0;
    this.onLoad(true);
    this.init();
  },
  mounted: function mounted() {}
};